import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { CONTACT } from '../../data/site';
import { trackCta } from '../../utils/tracking';
export function WhatsAppFab() {
  return <a href={CONTACT.whatsappHref} target="_blank" rel="noreferrer" onClick={() => trackCta('WhatsApp', 'floating')} className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 bg-brand-600 px-4 py-3.5 text-sm font-semibold text-white shadow-lg transition-colors duration-150 ease-smooth hover:bg-brand-500" aria-label="Escribir por WhatsApp a Rabemar" data-id="element-438" data-mp="qfe7dfnj4xl5">
      <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-439" data-mp="19f1wdzl5v5o7" />
      <span className="hidden sm:inline" data-id="element-440" data-mp="19cfmvuepmg3c">WhatsApp</span>
    </a>;
}